export default __webpack_public_path__ + "static/media/search.453e74b8.svg";